import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../Components/SEO';

export default function NotFound() {
  return (
    <>
      <SEO
        title="404 - Page Not Found"
        description="Page not found - VetCare Store"
        noIndex={true}
        canonical={typeof window !== 'undefined' ? `${window.location.origin}${window.location.pathname}` : ''}
        type="website"
      />
      <section className="section" style={{ textAlign: 'center', padding: '80px 20px 100px', minHeight: '80vh', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center' }}>
        <div className="container">
          <h1 style={{ fontSize: '8rem', color: 'var(--portland-orange)', fontFamily: 'var(--ff-bangers)', lineHeight: 1 }}>404</h1>
          <h2 className="h2" style={{ marginBottom: '20px' }}>Page Not Found</h2>
          <p style={{ fontSize: '1.8rem', color: 'var(--sonic-silver)', marginBottom: '30px', maxWidth: '500px', marginInline: 'auto' }}>
            Oops! The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
          </p>
          <Link to="/" className="btn">Go to Homepage</Link>
        </div>
      </section>
    </>
  );
}
